import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import Maintenancecontractlist from "./MaintenanceContractList";

const MaintenanceContractListPage = () => {
  return (
    <NavHeightAdjust>
      <Maintenancecontractlist />
    </NavHeightAdjust>
  );
};

export default MaintenanceContractListPage;
